export const networkingEvents = [
  {
    icon: "🍽️",
    title: "Welcoming Reception and Dinner",
    description:
      "An exclusive opportunity for key stakeholders and high-level participants.",
  },
  {
    icon: "🛠️",
    title: "Specialized Workshops",
    description:
      "Sessions focusing on specific governance topics, regions, or sectors.",
  },
  {
    icon: "🌿",
    title: "Governance Retreats",
    description: "Small group discussions and policy brainstorming sessions.",
  },
  {
    icon: "🎙️",
    title: "Forum of Former Leaders",
    description:
      "Interactive discussions with former leaders and policymakers sharing governance experiences.",
  },
];
